// A text names a thing or describes it, never both: saving one kind of link
// makes the server delete the other kind between the same text and target,
// listed in the response as `replacedLinks`. Drop those from a local list.
export function dropReplacedLinks(connections, response) {
  const gone = new Set((response?.replacedLinks || []).map(l => String(l._id)));
  return gone.size ? connections.filter(c => !gone.has(String(c._id))) : connections;
}
